import React, { Component } from 'react'
import { Grid, Slider, Box } from "@material-ui/core";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';

const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
  color: 'black',
  border: '1px solid black', // Add border to the button
  '&.Mui-selected': {
    backgroundColor: '#3f51b5', // Darker blue color
    color: 'white',
    border: '1px solid black', // Add border to the selected button
  },
  '&:not(.Mui-selected)': {
    backgroundColor: 'grey',
    border: '1px solid black', // Add border to the non-selected button
  },
}));

class ViewPane extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dimensions: {},
      checked: this.props.filterGrey,
      scaleValue: this.props.scaleMin,
      clusterColor: 'disabled',
      // zoomValue: this.props.scaleMax
    }
  }

  handleChange = () => {
    this.setState(prevState => ({
      checked: !prevState.checked
    }));
    this.props.handleChangeGrey(this.state.checked ? 1 : 0);
  }

  handleScaleChange = (event, newValue) => {
    this.setState({ scaleValue: newValue });
    this.props.handleChangeScale(event, newValue);
  };

  handleSelectChange = (event, newclusterColor) => {
    if (newclusterColor !== null) {
      this.setState({ clusterColor: newclusterColor });
      this.props.handleChangeCluster(event, newclusterColor);
    }
    // this.props.handleChangeCluster;
  }

  // handleZoomChange = (event, newValue) => {
  //   this.setState({ zoomValue: newValue });
  //   this.props.handleChangeZoom(event, newValue);
  // };

  render() {
    let {
      clusters
    } = this.props

    return (
      <Grid container>
        <Grid container alignItems="center">
          <Grid item xs={4}>
            coloring:
          </Grid>
          <Grid item xs={8}>
            {/* <select onChange={this.props.handleChangeCluster}>
              <option key="0" value="disabled">-</option>
              {clusters['clusterList'].map((option, index) => (
              <option key={option} value={option}>
                  {option.toLowerCase()}
              </option>
              ))}
            </select>  */}
            <ToggleButtonGroup
            size="small"
            fullWidth

                value={this.state.clusterColor}
                exclusive
                onChange={this.handleSelectChange}
              aria-label="text clusterColor"
            >
              <CustomToggleButton value="disabled">none</CustomToggleButton>
              <CustomToggleButton value="category">fruit</CustomToggleButton>
              <CustomToggleButton value="style">style</CustomToggleButton>
           </ToggleButtonGroup>
           </Grid>
          </Grid>
          <Grid container alignItems="center" style={{ marginTop: '12px' }}>
          <Grid item xs={4}>
            size:
          </Grid>
          <Grid item xs={8}>
          <Box height={10}>
          <Slider
            size="small"
            value={this.state.scaleValue}
            min={8}
            max={80}
            onChange={this.handleScaleChange}
          />
          </Box>
          </Grid>
          </Grid>
          {/* <Grid item xs={4}>
          size (in):
          </Grid> */}
          {/* <Grid item xs={8}> */}
          {/* <Box height={10}>
          <Slider
            size="small"
            value={this.state.zoomValue}
            min={3}
            max={400}
            onChange={this.handleZoomChange}
          />
          </Box> */}
          {/* </Grid> */}

          {/* <Grid item xs={11}>
          show filtered-out items (slower):
          </Grid>
          <Grid item xs={1}>
            <input type="checkbox" 
            checked={this.state.checked} 
            onChange={this.handleChange}
            />
          </Grid> */}

      </Grid>
    )
  }
}

export default React.memo(ViewPane)
